<template>
    <div>
        <template v-if="isStatic">
            <div class="form-control form-control--static" :class="className">
                {{ item.title }}
            </div>
        </template>
        <template v-else>
            <select :id="id" :name="name" class="form-control form-control--select" :class="className" :tabindex="tabindex" @change="onChangeItem" :style="style">
                <template v-if="hasPlaceholder">
                    <option value="">{{ placeholder }}</option>
                </template>
                <template v-for="item in items">
                    <option :value="item.id" :selected="isSelectedItem(item.id)">{{ item.title }}</option>
                </template>
            </select>
        </template>
    </div>
</template>

<script>
    export default {
        props : {
            id : {
                type : String,
                default : 'form-element-active'
            },
            name : {
                type : String,
                name : 'active'
            },
            value : {
                type : [String, Number, Boolean],
                default : ''
            },
            placeholder : {
                type : String,
                default : ''
            },
            className : {
                type : String,
                default : ''
            },
            style : {
                type : String,
                default : ''
            },
            tabindex : {
                type : [String, Number],
                default : ''
            },
            isStatic : {
                type : Boolean,
                default : false
            }
        },
        data() {
            return {
                item    : {
                    title : ''
                },
                items   : this.getItems()
            };
        },
        computed : {
            hasPlaceholder : function () {
                return this.placeholder !== '';
            }
        },
        methods : {
            getItems : function () {
                var actives = [];

                this.$helpers.active.forEach((function (active) {
                    actives.push({
                        id      : active,
                        title   : this.$t('active.active_' + active)
                    });
                }).bind(this));

                return actives;
            },
            onSelectItem : function (id) {
                this.$emit('input', id);
                this.$emit('change', this.getItemById(id));
            },
            onChangeItem : function (event) {
                this.onSelectItem(event.currentTarget.value);
            },
            isSelectedItem : function (id) {
                return Number(this.value) === Number(id);
            },
            getItemById : function (id) {
                var output = null;

                this.items.forEach((function (item) {
                    if (parseInt(item.id) === parseInt(id)) {
                        output = item;
                    }
                }).bind(this));

                return output;
            }
        }
    }
</script>
